import FAQSection from './faqSection/FAQSection';
import Section1 from './section1/Section1';
import Section2 from './section2/Section2';
import Section3 from './section3/Section3';
import Section4 from './section4/Section4';

import './LoggedOutHome.css';

function LoggedOutHome() {
  return (
    <div className='logged-out-home'>
      <Section1/>
      <Section2/>
      <Section3/>
      <Section4/>
      <FAQSection/>
    </div>
  );
}

export default LoggedOutHome;
